import { AnyAction } from 'redux';

export interface AsyncData<T> {
  data?: T;
  isFetching: boolean;
  error?: string;
}

export const pending = (type: string): string => `${type}-pending`;
export const success = (type: string): string => `${type}-success`;
export const failure = (type: string): string => `${type}-failure`;

export function setAsyncData<T>(asyncData: AsyncData<T>, update: (asyncData: AsyncData<T>) => void): AsyncData<T> {
  const clone = {
    ...asyncData,
  };
  update(clone);
  return clone;
}

export interface BaseAction<T = string, D = any> {
  type: T;
  data: D;
}

export interface ReduxAction<T = any> extends AnyAction {
  data: T;
  meta?: any;
}

export function onPageDidMount(name: string) {
  return {
    type: 'PAGE_DID_MOUNT/' + name,
    data: '',
  };
}

export function onPageWillUnmount(name: string) {
  return {
    type: 'PAGE_WILL_UNMOUNT/' + name,
    data: '',
  };
}
